import { cn } from "../../lib/utils.mjs";
import { focusRing } from "../../lib/focus.mjs";
import * as React from "react";
import { cva } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
//#region src/components/ui/button.tsx
const buttonVariants = cva(cn("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-label transition-colors", focusRing, "focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50"), {
	variants: {
		variant: {
			default: "bg-surface-action-1 text-text-on-action-1 hover:bg-surface-action-hover-1 active:bg-surface-action-click-1",
			accent: "bg-surface-action-2 text-text-on-action-1 hover:bg-surface-action-hover-2 active:bg-surface-action-click-2",
			glass: "border border-foreground/10 bg-glass-menu text-text-on-action-2 shadow-sm hover:bg-background active:bg-surface-click-1 reduce-transparency:bg-background",
			destructive: "bg-destructive text-destructive-foreground hover:bg-error-400 active:bg-error-400",
			outline: "border border-border-action bg-transparent text-text-on-action-2 hover:border-border-hover hover:text-text-hover-1 active:border-border-click active:text-text-click-1",
			ghost: "hover:bg-accent hover:text-accent-foreground",
			link: "text-primary underline-offset-4 hover:underline"
		},
		size: {
			default: "h-11 px-6 text-label-md font-semibold",
			sm: "h-8 px-4 text-sm font-medium",
			lg: "h-13 px-6 text-label-md font-medium",
			icon: "size-11 font-medium",
			"icon-sm": "size-8 text-sm"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
});
const Button = React.forwardRef(function Button({ className, variant, size, ...props }, ref) {
	return /* @__PURE__ */ jsx("button", {
		ref,
		type: props.type ?? "button",
		className: cn(buttonVariants({
			variant,
			size,
			className
		})),
		...props
	});
});
//#endregion
export { Button, buttonVariants };
